import { useMutation } from '@tanstack/react-query';
import { updateAllTasksCollapsedGoals } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useUpdateAllTasksCollapsedGoalsMutation = () =>
  useMutation({
    mutationFn: async (newOrder: ID[]) =>
      updateAllTasksCollapsedGoals(newOrder),
  });
